import React from "react";
import { LeftMenu } from "..";
import { Dock } from "react-dock";
import { RxCross1 } from "react-icons/rx";

export const MobileMenu = ({ position, isVisible, onMenuClose }) => {
    return <Dock
              position={position}
              isVisible={isVisible}
              size={1.0}
              onVisibleChange={onMenuClose}>
        <div onClick={onMenuClose} className="closeCls">
          <RxCross1 size={30} />
        </div>
        <div className="h-100">
          <LeftMenu />
        </div>
    </Dock>;
};

